import IphoneDinamic from './IphoneDinamic'
export default IphoneDinamic
